import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  queryTask: (params: {
    page: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    status?: string;
  }) => defHttp.get({ url: `/aiad/pod/tasks`, params }),

  addTask: (params: {
    image?: string;
    file?: string;
    needMatting?: boolean;
    needGenerate?: boolean;
    ar?: string;
    mockupParams?: any;
    generateType?: 'ID' | 'MJ';
    horizontal?: boolean;
  }) => defHttp.post({ url: `/aiad/pod/tasks`, params }),

  handleTask: (id: string | number, params?: { result: number }) =>
    defHttp.post({ url: `/aiad/pod/tasks/${id}`, params }),

  autoGoods: (params) => defHttp.post({ url: `/cdp/auto-goods`, params }),
  getAutoGoods: (params?) => defHttp.get({ url: `/cdp/auto-goods`, params }),
  exportGoods: (params) => defHttp.post({ url: '/cdp/export-goods', params }),

  updateGoods: (params) => defHttp.put({ url: '/cdp/auto-goods', params }),

  /** POD 商品品类（一级 + 二级） */
  getCategoryNew: () => defHttp.get({ url: '/aiad/pod/category-new' }),
});
